import MainMap, { type MapPoint } from "@/UI/components/MainMap";
import "./styles.css";

export interface MapViewPopupDetails {
    title?: string;
    lat: number;
    lng: number;
}

interface Props {
    onClose: () => void;
    details?: MapViewPopupDetails;
}

export default function MapViewPopup({ onClose, details }: Props) {
    if (!details) return null;

    const { title, lat, lng } = details;

    const points: MapPoint[] = [{ lat, lng, color: "orange", title }];

    return (
        <div className="map-view-popup">
            {title && <div className="map-view-popup-header">{title}</div>}
            <div className="map-view-popup-map">
                <MainMap lat={lat} lng={lng} zoom={14} points={points} height={350} showControls={true} />
            </div>
            <div className="map-view-popup-footer">
                <span className="map-view-popup-coords">
                    {lat.toFixed(6)}, {lng.toFixed(6)}
                </span>
                <button type="button" className="map-view-popup-close" onClick={onClose}>
                    <img src="/icons/close-icon.svg" alt="" width={14} height={14} />
                </button>
            </div>
        </div>
    );
}
